// Maps a panel-owned transport code to ES copy for «Notificar mismatch». Unlike its siblings, the
// codes are not backend's: the report goes to a Google Sheet, and the host translates Google's
// statuses and the consent popup's outcomes into these seven before they reach the slice.
//
// The first three MUST read differently — the agent's next move differs for each: an expired
// session is a retry, a missing permission is a request to whoever owns the sheet, and a sheet that
// is gone is a report to whoever maintains the integration. Only the unknown/absent case falls open
// to a generic, and neither the code nor any text from Google is ever rendered.
// TODO: i18n — copy en ES hasta Fase 1.
const SPECIFIC: Record<string, string> = {
  SHEETS_NOT_AUTHORIZED: 'Tu sesión de Google ha caducado. Vuelve a intentarlo.',
  SHEETS_FORBIDDEN:
    'Tu cuenta no tiene permiso para escribir en la hoja. Pide acceso a quien la gestiona.',
  SHEETS_NOT_FOUND: 'No se encuentra la hoja del reporte. Avisa a quien mantiene la integración.',
  SHEETS_RATE_LIMITED: 'Google está limitando los envíos. Espera un momento y vuelve a intentarlo.',
  SHEETS_CONSENT_DISMISSED: 'No se ha dado permiso a Google para escribir en la hoja.',
  SHEETS_POPUP_BLOCKED:
    'El navegador ha bloqueado la ventana de Google. Permite las ventanas emergentes y vuelve a intentarlo.',
  SHEETS_UNAVAILABLE: 'No se ha podido contactar con Google. Vuelve a intentarlo.',
};

export function addressMismatchError(code: string | null): string {
  // Own-property only, as in the siblings: a bare lookup also resolves inherited names.
  const message = code !== null && Object.hasOwn(SPECIFIC, code) ? SPECIFIC[code] : undefined;
  return message ?? 'No se pudo enviar el reporte. Inténtalo de nuevo.'; // TODO: i18n
}
